import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import NavbarBottom from './NavbarBottom';
import no_image_available from '../images/no_image_available.jpg';

const AgendaList = () => {

    const [newsList, SetNews] = useState([]);
    const [newsLink, SetNewsLink] = useState([]);
    const [dataToDisplay, setDataToDisplay] = useState([]);

    const urlImg = `${process.env.REACT_APP_BASEURL}/berita/`;

    const handleSearchPageNext = async (e) => {
        //console.log(e);
        fetch(`${process.env.REACT_APP_API_ENDPOINT}/agenda?page=${e}`)
            .then((response) => response.json())
            .then((res) => {
                SetNews(res.data.data);
                //console.log(res.data);
            });
    }

    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_ENDPOINT}/agenda`)
            .then((res) => {
                return res.json();
            })
            .then((datas) => {
                //console.log(datas);
                SetNews(datas.data.data);
                SetNewsLink(datas.data.links);
            });
    }, []);


    return (
        <>
            <NavbarBottom />
            <div class="max-w-full h-auto mx-auto flex flex-col items-center pt-20">
                <h1 class="text-[56px] font-bold text-[#0f0f1c]">Agenda</h1>
                <p class="text-[#888888] text-lg mt-2">Agenda JDIH Kota Magelang</p>

                <div class="flex items-center justify-center lg:h-screen">
                    <div class="container mx-auto mx-auto p-4">
                        <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-4 xl:grid-cols-4 gap-4">
                            {newsList.map((data_news, indexnews_list) => (
                                <div class="bg-white rounded-lg border p-4">
                                    {data_news?.images != '' ?
                                        <img src={urlImg + '' + data_news.images} alt="Agenda Image" class="w-full h-48 rounded-md object-cover" />
                                        :
                                        <img src={no_image_available} alt="" />
                                    }
                                    <div class="px-1 py-4">
                                        <p class="text-gray-700 text-base text-left">
                                            {data_news.title}
                                        </p>
                                    </div>
                                    <div class="px-1 py-4">
                                        <Link to={`/detail-agenda/${data_news.id}/${data_news.link}`} class="max-w-sm mx-auto group hover:no-underline focus:no-underline dark:bg-gray-50">
                                            Read More
                                        </Link>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AgendaList;
